<template>
  <div style="margin-left: 40px">
    <h3>{{ this.title }}</h3>
    <q-card class="my-card" v-if="data">
      <q-card-actions class="header">
        <div color="primary">{{ $gettext("CODE") }}: {{ data.id }}</div>
        <div>
          <q-btn
            v-if="ownershipChange"
            flat
            @click="() => $emit('replace', this.data)"
          >
            <q-icon name="autorenew" size="25px" />
          </q-btn>
          <q-btn id="edit-button" flat @click="() => $emit('edit', this.data)">
            <q-icon name="edit" size="25px" />
          </q-btn>
        </div>
      </q-card-actions>
      <q-card-section class="bg-ice card-selection">
        <div class="cliente-name">
          <q-icon name="person" size="30px" />
          {{ data.name }}
        </div>
      </q-card-section>
      <q-card-section class="card-selection">
        <span class="text-subtitle2" style="width: 50%">
          {{ $gettext("CPF_CNPJ") }}:
          <span class="text-subtitle1">{{ data.document }}</span>
        </span>
        <span
          class="text-subtitle2"
          style="width: 50%"
          v-if="!data.legalEntity.id"
        >

          {{ $gettext("DATE_OF_BIRTH") }}:
          <span class="text-subtitle1">{{
            moment(data.physicalPerson.birthDate).format('DD/MM/YY')

          }}</span>
        </span>
      </q-card-section>

      <q-card-section class="bg-ice card-selection">
        <span class="text-subtitle2" style="width: 50%">
          <q-icon name="email" size="22px" />
          <span class="text-subtitle1"> {{ data.email }}</span>
        </span>
        <span
          class="text-subtitle2"
          style="width: 50%"
          v-if="dataCard.legalEntity.id"
        >
          I.E:
          <span class="text-subtitle1"> </span>
        </span>
      </q-card-section>
      <q-card-section class="card-selection" v-if="!dataCard.legalEntity.id">
        <span class="text-subtitle2" style="width: 50%">
          {{ $gettext("LABEL_PESSOA_NM_PESSOA_PAI") }}:
          <span class="text-subtitle1">{{
            data.physicalPerson.fatherName
          }}</span>
        </span>
        <span class="text-subtitle2" style="width: 50%">
          {{ $gettext("LABEL_PESSOA_NM_PESSOA_MAE") }}:
          <span class="text-subtitle1">{{
            data.physicalPerson.motherName
          }}</span>
        </span>
      </q-card-section>
      <q-card-section class="bg-ice card-selection">
        <div style="width: 50%">
          <q-icon name="phone" size="22px" />
          <span class="text-subtitle1">
            {{ data.alternativePhone }}
          </span>
        </div>
        <div style="width: 50%">
          <q-icon name="phone" size="22px" />
          <span class="text-subtitle1">
            {{ data.phone }}
          </span>
        </div>
      </q-card-section>
    </q-card>
  </div>
</template>
<script>
import { Component, Vue } from 'vue-property-decorator'
import { JtCrud } from 'jtech-webcomps'
import moment from 'moment'

const { pageDetail } = JtCrud

@Component({
  mixins: [pageDetail],
  name: 'ClientUnitCard',
  components: {
    pageDetail
  },
  props: {
    data: Object,
    title: String,
    ownershipChange: Boolean
  }
})
class ClientUnitCard extends Vue {
  moment = moment
  get dataCard () {
    return this.data
  }
}
export default ClientUnitCard
</script>
<style lang="stylus" scoped>
@import '~quasar-variables';
.my-card {
  width: 72vh;
  height: 260px;
  margin: 0px 10px 20px 0px !important;
  padding: 15px !important;
}
.text-subtitle1 {
  color: $light-d;
}
h3 {
  font-size: 20px;
  margin: 0;
  color:$light-d;
}
.cliente-name {
  font-size: 17px;

}
.header {
  padding: 0;
  display: flex;
  justify-content:space-between;
}
.card-selection {
  padding: 0 11px;
  height: 38px;
  display: flex;
  flex-direction:row;
  justify-content: space-between;
  align-items: center
}
</style>
